import { apiRequest } from "../../../apiHelper/apiRequest";
import { serialize } from "../../../helpers/helpers";


const list = async (params) => {
	return apiRequest(
        "/vacancies/type/list?" + serialize(params),
        {
            'method': "GET"
        },
        'ptp_client'
    );
}


const add = async ( params ) => {
    let add_response = await apiRequest(
                                "/vacancies/type/add",
                                {
                                    'method': "POST",
                                    'headers': {
                                        'content-type' : 'application/json'
                                    },
                                    'body': JSON.stringify(params)
                                },
                                'ptp_client'
                            );
    if ( typeof(add_response.id) !== 'undefined' && add_response.id )
        return add_response.id;
    else
        return 0;
}


const update = async ( params ) => {
    let add_response = await apiRequest(
                                "/vacancies/type/update",
                                {
                                    'method': "PUT",
                                    'headers': {
                                        'content-type' : 'application/json'
                                    },
                                    'body': JSON.stringify(params)
                                },
                                'ptp_client'
                            );
    if ( typeof(add_response.id) !== 'undefined' && add_response.id )
        return add_response.id;
    else
        return 0;
}


const remove = async ( id = 0 ) => {
    let remove_response = await apiRequest(
                                "/vacancies/type/delete/" + id,
                                {
                                    'method': "DELETE"
                                },
                                'ptp_client'
                            );
    if ( typeof(remove_response.id) !== 'undefined' && remove_response.id )
        return remove_response.id;
    else
        return 0;
}


const VacancyCategories = {
    list,
    add,
    update,
    remove
};
export default VacancyCategories;